<template>
  <div>
    <div class="container">
      <div class="app-container">
        <div>
          <p style="margin: 10px 0px; padding: 5px 10px; font-size: 20px; color: white; background-color: #242f42">{{ pageTitle }}</p>
        </div>
        <!-- 筛选项 -->
        <div>
          <span>关键字：</span>
          <el-input v-model="listQuery.notice_title" style="width: 150px"></el-input>
          <span style="margin-left: 20px">上传时间：</span>
          <el-date-picker v-model="listQuery.created_at" type="daterange" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd" style="width: 250px"></el-date-picker>
          <span v-if="listQuery.notice_level !== 3" style="margin-left: 20px">游戏：</span>
          <el-select v-if="listQuery.notice_level !== 3" v-model="listQuery.game_id" filterable placeholder="游戏名称">
            <el-option v-for="item in gameNameOpions" :key="item.index" :label="item.name" :value="item.id"></el-option>
          </el-select>
          <span style="margin-left: 20px">上传人：</span>
          <el-select v-model="listQuery.admin_id" filterable placeholder="上传人">
            <el-option v-for="item in adminOpions" :key="item.index" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </div>
        <!-- 右侧按钮 -->
        <div style="float: right; margin: 30px 30px 20px 0">
          <el-button class="filter-item" style="margin-left: 10px" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
          <el-button type="primary" class="filter-item" style="margin-left: 10px" @click="resetAll">重置</el-button>
          <el-button class="filter-item" style="margin-left: 10px" type="warning" @click="showFirstPage(1)">展示首页</el-button>
          <el-button class="filter-item" style="margin-left: 10px" type="warning" @click="showFirstPage(0)">取消置顶</el-button>
        </div>
        <!-- 表单 -->
        <div>
          <el-table min-height="200" max-height="1000" border v-loading="listLoading" :data="tableData" @selection-change="handleSelectionChange" style="width: 100%">
            <el-table-column type="selection" class="el-checkbox__inner" width="50" />
            <el-table-column v-if="listQuery.notice_level !== 3" prop="game_name" label="游戏" />
            <el-table-column prop="title" label="标题" :show-overflow-tooltip="true">
              <template scope="scope">
                <span :style="{ cursor: 'pointer', color: scope.row.is_top === 1 ? 'red' : '#606266', fontWeight: scope.row.is_read === 0 ? 'bold' : 'normal' }" @click="rowFunc(scope.row)">
                  {{ scope.row.notice_title }}</span
                >
              </template>
            </el-table-column>
            <el-table-column prop="admin_name" label="上传人" />
            <el-table-column prop="created_at" label="上传时间" />
            <el-table-column label="操作" width="250">
              <template slot-scope="scope">
                <el-button size="mini" type="primary" icon="el-icon-edit" @click="toEdit(scope.row)">编辑</el-button>
                <el-popover placement="top" width="160" v-model="scope.row.visible">
                  <p>确认删除？</p>
                  <div style="text-align: right; margin: 0">
                    <el-button size="mini" type="text" @click="scope.row.visible = false">取消</el-button>
                    <el-button type="primary" size="mini" @click="deleteRow(scope.row)">确定</el-button>
                  </div>
                  <el-button v-if="deleteShow" slot="reference" style="margin-left: 10px" size="mini" type="danger" icon="el-icon-delete">删除</el-button>
                </el-popover>
              </template>
            </el-table-column>
          </el-table>
          <pagination v-show="total > 0" :total="total" :page.sync="listQuery.page" :limit.sync="listQuery.limit" @pagination="getNoticeList" />
        </div>
        <!-- 添加弹窗 -->
        <Dialog ref="dialog" @submitForm="dialogSure" @closeDialog="closeDialog" :dialogTitle="dialogTitle" :dialogVisible="dialogVisible" :dialogModel="dialogModel" dialogWidth="700px"></Dialog>
        <!-- 查看弹窗 -->
        <Dialog
          ref="checkdialog"
          @submitForm="closeCheckDialog"
          @closeDialog="closeCheckDialog"
          :dialogTitle="'查看'"
          :dialogVisible="dialogCheckVisible"
          :dialogModel="checkDialogModel"
          dialogWidth="700px"
        ></Dialog>
      </div>
    </div>
  </div>
</template>
<script>
import Dialog from '@/components/common/Dialog';
import Pagination from '@/components/pagination/index';
import '@/assets/css/global.css';
import { readBulletinBoard, bulletinBoard, getBulletinBoardSelect, bulletinBoardGet, bulletinBoardPut, bulletinBoardDel, getSuggestionAdminSelect, topBulletinBoard } from '@/api/first_page.js';

export default {
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      switch (to.name) {
        case 'morePage.affice':
          vm.pageTitle = '重要通知';
          vm.listQuery.notice_level = 1;
          break;
        case 'morePage.activity':
          vm.pageTitle = '特定通知';
          vm.listQuery.notice_level = 2;
          break;
        case 'morePage.notify':
          vm.pageTitle = '部门资料';
          vm.listQuery.notice_level = 3;
          break;
        default:
          vm.pageTitle = '重要通知';
          vm.listQuery.notice_level = 1;
      }
    });
  },
  components: { Pagination, Dialog },
  data() {
    return {
      listLoading: false,
      formInputWidth: '200px',
      pageTitle: '', // 页面名称
      listQuery: {
        notice_level: 1, // 页面来源：通知类型 1重要通知 2特定通知 3部门资料
        notice_title: '',
        game_id: '',
        admin_id: '',
        created_at: [],
        page: 1,
        limit: 10,
      },
      total: 0, // 数据总数
      tableData: [], // 列表数据
      deleteShow: false, // 是否展示删除按钮
      gameNameOpions: [], // 游戏筛选项列表
      adminOpions: [], // 上传人筛选项列表
      dialogVisible: false,
      dialogTitle: '编辑',
      currentId: 0, // 当前选中的id
      dialogCheckVisible: false,
      multipleSelection: [],
    };
  },
  mounted() {
    setTimeout(() => {
      this.getNoticeList();
      this.getSelectList();
      this.getSuggestionAdminSelect();
    }, 100);
  },
  computed: {
    dialogModel() {
      return [
        this.listQuery.notice_level !== 3 && {
          type: 'el-select',
          label: '游戏',
          prop: 'game_id',
          options: this.gameNameOpions,
        },
        {
          type: 'el-input',
          label: '标题',
          prop: 'notice_title',
        },
        {
          type: 'el-input-textarea',
          label: this.listQuery.notice_level === 3 ? '在线链接' : '通知内容',
          prop: 'content',
          rows: 12,
        },
        (this.listQuery.notice_level === 1 || this.listQuery.notice_level === 2) && {
          type: 'el-upload-image-list',
          label: '上传图片',
          prop: 'notice_images',
        },
        this.listQuery.notice_level === 2 && {
          type: 'el-tree-select',
          label: '被通知人',
          prop: 'to_admin_id',
          options: this.adminOpions,
          isMultiple: true,
        },
      ];
    },
    checkDialogModel() {
      return [
        {
          type: 'el-input-textarea',
          label: this.level === 3 ? '在线链接' : '通知内容',
          prop: 'content',
          rows: 12,
        },
        {
          type: 'el-image-swiper',
          label: '图片',
          prop: 'notice_images',
          showPagination: true,
        },
      ];
    },
  },
  methods: {
    // 获取筛选项列表
    async getSelectList() {
      const { data } = await getBulletinBoardSelect();
      if (data.code !== 200) return;
      this.gameNameOpions = data.data.game;
    },
    // 获取列表
    async getNoticeList() {
      this.listLoading = true;
      const obj = {};
      if (this.listQuery.created_at.length === 0) {
        Object.assign(obj, this.listQuery);
      } else {
        Object.assign(obj, this.listQuery, { created_at_begin: this.listQuery.created_at[0], created_at_end: this.listQuery.created_at[1] });
      }
      delete obj.created_at;
      const { data } = await bulletinBoard(obj);
      if (data.code !== 200) return;
      this.tableData = data.data.data;
      this.total = data.data.total;
      this.deleteShow = data.data.delete_button;
      this.listLoading = false;
    },
    async getSuggestionAdminSelect() {
      const { data } = await getSuggestionAdminSelect();
      // 映射
      const obj = { hangzhou: '杭州', shandong: '山东', normal: '普通客服', vip: 'VIP客服' };
      const treeData = Object.keys(data.data).map((m) => {
        // 获取vip节点下面的子结构
        const vipKeys = Object.keys(data.data[m]['vip']);
        return {
          id: m,
          label: obj[m],
          children: [
            {
              id: `${m}-normal`,
              label: obj['normal'],
              children: data.data[m]['normal'].map((o) => ({ id: o.id, label: o.name })),
            },
            {
              id: `${m}-vip`,
              label: obj['vip'],
              children: vipKeys.map((n, i) => ({ id: `${m}-vip-${n}`, label: `VIP客服${i + 1}组`, children: data.data[m]['vip'][n].map((o) => ({ id: o.id, label: o.name })) })),
            },
          ],
        };
      });
      this.adminOpions = treeData;
    },
    search() {
      this.listQuery.page = 1;
      this.getNoticeList();
    },
    resetAll() {
      this.listQuery.notice_title = '';
      this.listQuery.created_at = [];
      this.listQuery.game_id = '';
      this.listQuery.admin_id = '';
      this.listQuery.page = 1;
      this.listQuery.limit = 10;
      this.getNoticeList();
    },
    rowFunc(row) {
      this.readBulletinBoardPut(row.id);
      // 重要通知 & 特定通知
      if (row.notice_level === 1 || row.notice_level === 2) {
        if (row.notice_source === 1) {
          this.openCheckDialog(row);
        } else if (row.notice_source === 2 && row.content != '') {
          window.open(row.content, '_blank');
        } else if (row.notice_source === 2 && row.content == '') {
          this.$message({ message: '文件为空，仅显示标题', type: 'warning' });
        }
        return;
      }
      // 部门资料
      if (row.notice_source === 1) {
        window.open(row.content, '_blank');
      } else if (row.notice_source === 2 && row.content != '') {
        window.open(row.content, '_blank');
      } else if (row.notice_source === 2 && row.content == '') {
        this.$message({ message: '文件为空，仅显示标题', type: 'warning' });
      }
    },
    async toEdit(row) {
      this.currentId = row.id;
      const { data } = await bulletinBoardGet(row.id);
      if (data.code !== 200) return;
      this.dialogVisible = true;
      const obj = { ...data.data };
      delete obj.notice_images;
      this.$refs.dialog.resetForm();
      this.$refs.dialog.editForm(obj);
    },
    // 点击确定
    async dialogSure(form) {
      form.notice_images && (form.notice_images = form.notice_images.map((m) => m.url));
      const obj = Object.assign({ id: this.currentId }, form);
      const { data } = await bulletinBoardPut(obj);
      if (data.code !== 200) {
        this.$message.error(data.message);
        return;
      }
      this.$message.success('操作成功');
      this.closeDialog();
      this.getNoticeList();
    },
    // 点击关闭弹窗
    closeDialog() {
      this.currentId = 0;
      this.dialogVisible = false;
      this.$refs.dialog.resetForm();
    },
    // 删除行
    async deleteRow(row) {
      row.visible = false;
      const { data } = await bulletinBoardDel({ id: row.id });
      if (data.code !== 200) return;
      this.$message.success('操作成功');
      this.getNoticeList();
    },
    // 点击关闭查看弹窗
    closeCheckDialog() {
      this.dialogCheckVisible = false;
      this.$refs.checkdialog.resetForm();
    },
    // 点击打开查看弹窗
    openCheckDialog(row) {
      this.dialogCheckVisible = true;
      this.$refs.checkdialog.resetForm();
      this.$refs.checkdialog.editForm(row);
    },
    async showFirstPage(type) {
      if (this.multipleSelection.length == 0) {
        this.$message.error('请先选择文件');
        return;
      }
      let data = {
        id_array: this.multipleSelection,
        type,
      };
      const r = await topBulletinBoard(data);
      if (r.data.code !== 200) return;
      this.$message.success('操作成功');
      this.getNoticeList();
    },
    handleSelectionChange(val) {
      let ids = [];
      for (let item of val) {
        ids.push(item.id);
      }
      this.multipleSelection = ids;
    },
    // 已读消息
    async readBulletinBoardPut(id) {
      await readBulletinBoard(id);
      this.getNoticeList();
    },
  },
};
</script>
<style scoped>
</style>